<template>
  <CCardBody>
    <ul class="py-1">
      <li class="d-flex justify-content-between">
        <span class="text-gray-800 font-weight-bold">{{ $t(`manageplan.component.card.subTotal.subTotal`) }}</span>
        <span class="text-gray-600">{{ subtotal ? formatNumber(subtotal) : '' }} €</span>
      </li>
      <li class="d-flex justify-content-between">
        <span class="text-gray-800 font-weight-bold"
          >{{ $t(`manageplan.component.card.subTotal.tax`) }}
          <CButton
            v-c-tooltip.hover="{
              content: `Placement`,
              placement: 'right-end',
            }"
            class="p-0 m-0"
          >
            <CIcon name="question" size="custom-size" :height="15" viewBox="0 0 32 32" class="mr-3" />
          </CButton>
        </span>
        <span class="text-gray-600" v-if="tax">{{ tax }} %</span>
        <span class="text-gray-600" v-else>{{ $t(`manageplan.component.card.subTotal.text-tax`) }} €</span>
      </li>
    </ul>
  </CCardBody>
</template>

<script>
import { currencyFormat, currencyFormatStyleEnum } from '@/utils/numbersFormatUtil.js'
import { mapGetters } from 'vuex'

export default {
  name: 'CardSubTotal',
  props: {
    tax: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      placements: ['right-start', 'right', 'right-end', 'left-start', 'left', 'left-end'],
    }
  },

  computed: {
    isSummary() {
      return this.place == 'summary'
    },

    subtotal() {
      // paymentPeriod = 3 é anual
      return this.period == 3
        ? (this.$store.state.backOffice.steps.mount * 12).toFixed(2)
        : parseFloat(this.$store.state.backOffice.steps.mount).toFixed(2)
    },
    period() {
      return this.$store.state.backOffice.steps.paymentPeriod
    },

    ...mapGetters({
      lang: 'getLang',
    }),
  },

  methods: {
    formatNumber(number) {
      return currencyFormat(number, currencyFormatStyleEnum.DECIMAL)
    },

    applyDiscount(value) {
      if (this.period == 3) {
        let discount = value * 0.1
        let newValue = (value - discount) * 12
        return newValue.toFixed(1)
      }

      return value
    },
  },
}
</script>

<style lang="scss">
.tooltip-old-inner {
  background: #fff;
  color: #000;
  border: 1px solid #ccc;
}
.bs-tooltip-old-auto[x-placement^='right'] .arrow:before,
.bs-tooltip-old-right .arrow:before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #fff;
}
</style>
